var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetMasteredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1868_3994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3571 14.5713L12.5 18.4284L16.3571 22.2856",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64355 9.42815L12.5007 5.57101L8.64355 1.71387",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.4284H20.2143C21.1236 18.4284 21.9957 18.0672 22.6387 17.4242C23.2816 16.7812 23.6429 15.9092 23.6429 14.9999V8.99986C23.6429 8.09055 23.2816 7.21848 22.6387 6.57549C21.9957 5.93251 21.1236 5.57129 20.2143 5.57129H17.6429",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 5.57129H4.78599C3.87668 5.57129 3.00461 5.93251 2.36163 6.57549C1.71865 7.21848 1.35742 8.09055 1.35742 8.99986V14.9999C1.35742 15.9092 1.71865 16.7812 2.36163 17.4242C3.00461 18.0672 3.87668 18.4284 4.78599 18.4284H7.35742",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 1.5,
    stroke: "#1377D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1868_3994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetMasteredIcon);
export default __webpack_public_path__ + "static/media/reset-mastered-icon.3861aad061c080ac2b8cac1fa36a00ef.svg";
export { ForwardRef as ReactComponent };